import React from 'react';

import { FavouriteStationsDesktopButton } from './FavouriteStationsDesktopButton';

import { useShowFavouriteStations } from 'entities/stations';

export const FavouriteStationsButton = () => {
  const showFavouriteStations = useShowFavouriteStations();

  if (!showFavouriteStations) {
    return null;
  }

  return <FavouriteStationsDesktopButton />;  
}